class CrypTools {
  stringToDouble64Hash(str){
    var hashArr = [
      str,
      new Date().getTime(),
      toBase64(str)
    ]

    var hash = hashArr.join("|")
    hash = toBase64(hash)
    
    return hash
  }
}

function toBase64(string){
  return new Buffer(string).toString('base64')
}
module.exports = CrypTools